export default "__VITE_ASSET__B0w_4Gpe__"